// src/reducers/index.js
import { combineReducers } from 'redux';
import examReducer from '../actions/examSlice';
import answerExamReducer from "../actions/answerExamSlice";
import createRecordReducer from '../actions/createRecordSlice';

const rootReducer = combineReducers({
  exams: examReducer,
  answerExam: answerExamReducer,
  contact: createRecordReducer
  // Add your reducers here
});

export default rootReducer;
